import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import SideBar from '../common/layout/sidebar.component.jsx'
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx"
import AccountDetailsSection from './account/detailsSection.component.jsx'
import CompanyDetailsSection from "./companyDetails/companyDetailsSection.component.jsx"
import AutomatedSettingsSection from './section/AutomatedSettingsSection'

class AccountSettings extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            taxes: [],
            fees: [],
            defaultTax: undefined,
            companyName: undefined,
            companyCity: undefined,
            companyCountry: undefined,
            companyCountryCode: undefined,
            companyPostalCode: undefined,
            companyState: undefined,
            companyStreet: undefined,
            companyPhoneNumber: undefined,
            companyEmail: undefined,
            companyDescriptionId: undefined,
            accountDefaultCurrency: undefined,
            companyLogoImageId: undefined,
        }

    }

    componentDidMount() {
        SideBar.activateMenu('account')

        AppContext.getApiClient().get( '/remove-pending-external-subscription' )
        
        AppContext.getApiClient().get('/accounts/company-descriptions').then((resDefault) => {
            var phoneNumbers = resDefault.attributes.organization.attributes.phoneNumbers
            var phoneNumber = ''
            if (phoneNumbers.length > 0) {
                phoneNumber = phoneNumbers[0]["phoneNumber"]
            }
            this.setState({
                companyName: resDefault.attributes.organization.attributes.name,
                companyAddress: resDefault.attributes.organization.attributes.address,
                companyPhoneNumber: phoneNumber,
                companyEmail: resDefault.attributes.organization.attributes.email,
                companyLogoImageId: resDefault.attributes.companyLogoImageId,
                companyDescriptionId: resDefault.id
            });
        });

    }

    render() {
        return (
            <div>
                <MyAccountTabs />
                <CompanyDetailsSection
                    companyName={this.state.companyName}
                    companyAddress={this.state.companyAddress}
                    companyPhoneNumber={this.state.companyPhoneNumber}
                    companyEmail={this.state.companyEmail}
                    companyDescriptionId={this.state.companyDescriptionId}
                    companyLogoImageId={this.state.companyLogoImageId}
                />
                <AccountDetailsSection />
                <AutomatedSettingsSection />
            </div>
        );
    }

}

export default AccountSettings


// WEBPACK FOOTER //
// ./src/settings/account.component.jsx